import { useAppSelector } from "../../app/hooks";

import { Stack } from "@mui/material";
import { GroupCard } from "./GroupCard";
import { selectGroups } from "../../features/daoTrang/daoTrangSlice";
import { saveOrCreateGroup } from "../../services/group/groupApi";
import { CommonEdit } from "../Content/CommonEdit";
import { MyContainer } from "../Layout/MyContainer";

const BcsEdit = ({ navigate, params = {} }) => {
  const { groupsId = [] } = params;
  const allGroups = useAppSelector(selectGroups);

  if (!allGroups) {
    navigate("/");
  }

  const groups = allGroups.filter((g) => groupsId.includes(g.id));

  function onSave() {
    console.log(" save group");
    try {
      groups.forEach(async (g) => {
        var { error } = await saveOrCreateGroup(g);
        if (error) {
          console.log(error);
        }
      });
      navigate(-1);
    } catch (ex) {
      console.log(ex.message);
    }
  }
  return (
    <CommonEdit
      onSave={onSave}
      oncancel={() => navigate(-1)}
      text={"Chỉnh sửa danh sách BCS"}
    >
      <MyContainer>
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          
          flexWrap="wrap"
          justifyContent="center"
        >
          {groups.map((group, i) => (
            <div key={i} style={{ margin: "1rem" }}>
              {GroupCard(i, group)}
            </div>
          ))}
        </Stack>
      </MyContainer>
    </CommonEdit>
  );
};
export default BcsEdit;
